import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { DataState } from '@shared/enums/DataState';
import { useUserEvalData } from './hooks/useUserEvalData';
import { EvaluationHistory } from '@modules/EvaluationModule/components/EvaluationHistory/EvaluationHistory';
import { DataErrorView } from '@shared/components/DataErrorView';
import { startEvalOnUserEvalPage } from './redux/actions';
import { useAuth } from '@shared/hooks/useAuth';
import { pageTitles } from '@shared/enums/pageTitles';
import { useTitle } from '@shared/hooks/useTitle';
import { useSelectEvals } from '@modules/EvaluationModule/components/MyTeamEvalReport/hooks/useSelectEvals';
import { setSelectedEvalsAction } from '../MyTeamEvalPage/redux/actions';
import { userProfileOfficeCountrySelector } from '@modules/App/pages/UserProfilePage/redux/selectors';
import { useExternalLinks } from '@modules/App/pages/ExternalLinksPage/hooks/useExternalLinks';
import { EvaluationPermissions } from '@modules/EvaluationModule/enums/evalPermissions';
import { userPermissionsSelector } from '@modules/App/redux/permissions/selectors';
import { AccessDeniedView } from '@shared/components/DataErrorView/components/AccessDeniedView';

export const UserEvalPage: React.FC = () => {
  const userEvalData = useUserEvalData();
  const isFailed = userEvalData.state === DataState.Rejected;
  const dispatch = useDispatch();
  const { currentUser } = useAuth();
  const setPageTitle = useTitle();
  useExternalLinks(userEvalData.data?.user.id);

  const onEvalStart = (id: string) => {
    dispatch(startEvalOnUserEvalPage(id));
  };
  const evaluateeName = userEvalData.data?.user.name;
  const { handleFailEopButtonClick, handlePassEopButtonClick, failingEopId, startingEvalId } =
    useSelectEvals(setSelectedEvalsAction);

  useEffect(() => {
    if (evaluateeName) {
      setPageTitle(`${evaluateeName} ${pageTitles.userEvalPage}`);
    }
  }, [evaluateeName]);

  const officeCountry = useSelector(userProfileOfficeCountrySelector);

  const userPermissions = useSelector(userPermissionsSelector);
  const hasAccess = !!userPermissions && userPermissions.data?.permissions.includes(EvaluationPermissions.Read);
  const isDataLoading = userPermissions.state === DataState.Pending || userEvalData.state === DataState.Pending;

  return isFailed ? (
    <DataErrorView error={userEvalData.error} />
  ) : !hasAccess && !isDataLoading ? (
    <AccessDeniedView />
  ) : (
    <EvaluationHistory
      data={userEvalData.data}
      isDataLoading={isDataLoading}
      currentUser={currentUser}
      onEvalStart={onEvalStart}
      onEopFail={handleFailEopButtonClick}
      onEopPass={handlePassEopButtonClick}
      currentlyStartedEvalId={startingEvalId}
      failingEopId={failingEopId}
      officeCountry={officeCountry}
    />
  );
};
